import { render } from "./payments.vue?vue&type=template&id=c586fc88&scoped=true"
import script from "./payments.vue?vue&type=script&lang=js"
export * from "./payments.vue?vue&type=script&lang=js"

import "./payments.vue?vue&type=style&index=0&id=c586fc88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c586fc88"]])

export default __exports__